
























import { Vue, Component } from "vue-property-decorator";
import { BrandConfigKeys } from "@/data/constants";
@Component
export default class AffiliateCustomerControlsWarning extends Vue {
  // Data
  public showWarning = false;

  // Lifecycle methods
  public async created() {
    try {
      const key = BrandConfigKeys.UPMIND_AFFILIATES_CUSTOMER_CONTROLS_ENABLED;
      const config = await this.$store.dispatch("brand/getConfig", {
        keys: [key]
      });
      this.showWarning = this.$_.get(config, key) === false;
    } catch {
      // Silent fail to allow page to continue
    }
  }
}
